var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightBird = function SvgArrowRightBird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1017.5 1780"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m980.5 799.6-763-762.4c-49.8-49.5-130.3-49.5-180.1 0l-.3.3c-49.4 49.6-49.2 129.8.3 179.2l673.2 672.9h.2L37.6 1563.4C14.1 1587.1.9 1619.2.8 1652.6c-.2 70.2 56.6 127.3 126.9 127.5 33.8.1 66.3-13.2 90.2-37.1l766.3-768c45.8-50.1 44.2-127.3-3.7-175.4"
  })));
};
export default SvgArrowRightBird;